import { GridColDef } from '@mui/x-data-grid';
import { Link } from '@mui/material';
import { DataGridLink } from '@carcareers/components';

import { routes } from '@carcareers/utils';

export const JOBSEEKER_INDEX_COLUMNS: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 },
  {
    field: 'name',
    headerName: 'Name',
    width: 200,
    renderCell: (params) => (
      <DataGridLink
        link={`/${routes.ADMIN_HOME}/${routes.ADMIN_JOBSEEKERS_VIEW.replace(':id', params.row.id.toString())}`}
        content={`${params.row.user.firstName} ${params.row.user.lastName}`}
      />
    ),
  },
  {
    field: 'email',
    headerName: 'Email',
    width: 250,
    valueGetter: (_, row) => row.user.email,
  },
  {
    field: 'totalApplications',
    headerName: 'Total Applications',
    width: 200,
    valueGetter: (_, row) => row.totalApplications || 0,
  },
  {
    field: 'activeApplications',
    headerName: 'Active Applications',
    width: 200,
    valueGetter: (_, row) => row.activeApplications || 0,
  },
  {
    field: 'updatedAt',
    headerName: 'Updated',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.updatedAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
  {
    field: 'createdAt',
    headerName: 'Joined',
    width: 150,
    valueGetter: (_, row) =>
      new Date(row.createdAt).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      }),
  },
];

export const JOBSEEKER_INDEX_COLUMN_INITIAL_STATE = {
  id: true,
  name: true,
  email: true,
  totalApplications: true,
  activeApplications: true,
  createdAt: true,
  updatedAt: false,
};

export const JOBSEEKER_INDEX_COLUMNS_INITIAL_STATE_MOBILE = {
  ...JOBSEEKER_INDEX_COLUMN_INITIAL_STATE,
  totalApplications: false,
  activeApplications: false,
  createdAt: false,
  updatedAt: false,
};